import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import {
  DataGrid,
  GridColDef,
  GridRowSelectionModel,
  GridSortModel,
} from "@mui/x-data-grid";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import { Tooltip as TP } from '@mui/material';
import { styled } from "@mui/material/styles";
import "./data.css";
import ActionDot from "../../assets/images/icons/more-action-icon.svg";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { CircularProgress } from "@mui/material";
import { Popconfirm, Tooltip as TpAd } from "antd";
import { AiOutlineAudit } from "react-icons/ai";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from 'react-icons/md';
import { MdControlPointDuplicate } from "react-icons/md";
import { log } from "util";
import Table from "../../views/Ads/BudgetRulestable/table";

let columns: GridColDef[] = [];

interface Header {
  keyName: string;
  displayName: string;
}
type TableProps = {
  headers: any;
  rows: any;
  fetchData: () => Promise<void>;
};

function AutomationRulesListTable(props) {
  let apiEndPoint = "https://adsexpert-api.getgrowth.agency/Rule/All";
  const [apiLoading, setApiLoading] = useState(false);
  const [rows, setIsRows] = useState<any>([]);
  const [header, setHeader] = useState<any>([]);
  const [tagInput, setTagInputValue] = useState("");
  const [selectedAccount, setSelectedAccount] = useState("");
  const [sortModel, setSortModel] = useState<GridSortModel>([]);
  const [sortModeldata, setSortModelData] = useState<any>([]);
  const [clickedId, setClickedId] = useState("");
  const [rowSelectionModel, setRowSelectionModel] =
    React.useState<GridRowSelectionModel>([]);

  const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#001912",
      color: "rgba(255, 255, 255, 0.87)",
      maxWidth: 350,
      fontSize: theme.typography.pxToRem(12),
      border: "1px solid #001912",
    },
  }));



const [sortKey, setSortKey] = useState<string>('');
const [sortOrder, setSortOrder] = useState<'asc' | 'desc'>('asc');

  const handleRowCheckboxChange = (id: string | number) => {
  setRowSelectionModel((prev) =>
    prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
  );
};

const handleSelectAllChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  if (e.target.checked) {
    const allIds = rows.map((row) => row.id);
    setRowSelectionModel(allIds); 
  } else {
    setRowSelectionModel([]); 
  }
};

const sortedRows = React.useMemo(() => {
  if (!sortKey) return rows;

  return [...rows].sort((a, b) => {
    const aValue = a[sortKey];
    const bValue = b[sortKey];

    if (aValue < bValue) return sortOrder === 'asc' ? -1 : 1;
    if (aValue > bValue) return sortOrder === 'asc' ? 1 : -1;
    return 0;
  });
  
}, [rows, sortKey, sortOrder]);


const handleSort = (field: string) => {
  if (sortKey === field) {
    setSortOrder((prev) => (prev === 'asc' ? 'desc' : 'asc'));
  } else {
    setSortKey(field);
    setSortOrder('asc');
  }
};
  useEffect(() => {
    const sort = JSON.parse(localStorage.getItem("Sort") || "[]");
    const sortData = JSON.parse(localStorage.getItem("SortData") || "[]");
   console.log(sort);

     console.log(columns,'columnscolumns');
   
   if(sort.length >0){
    setSortModelData(sort)
    setSortModel(sortData)
   }
  }, [])

  useEffect(() => {
    props.handleSelectedRules(rowSelectionModel);
  }, [rowSelectionModel]);

 useEffect(() => {
  console.log("Page reload triggered: ", props.pageReload);
  if (props.selectedAccount) {
    fetchData(); 
  }
}, [props.pageReload, props.fetchRulesByStatus, props.selectedAccount,props.searchKey]);

  const tagInputValue = (e) => {
    setTagInputValue(e.target.value);
  };

  const patchTagData = async () => {
    let userToken = localStorage.getItem("userToken");
    let AuthToken = "Bearer " + userToken;
    const response = await fetch(
      "https://api.aimosa.io/BookShelf/" + clickedId + "/Tag",
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: AuthToken,
        },
        body: JSON.stringify({
          tags: [tagInput],
        }),
      }
    );
    const responceData = await response;
    console.log("best=s", responceData);
    fetchData();
  };

  const cancel = () => {};

  const deleteRule = async (id, profileId) => {
    let userToken = localStorage.getItem("userToken");
    let AuthToken = "Bearer " + userToken;
    const response = await fetch(
      "https://adsexpert-api.getgrowth.agency/Rule",
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: AuthToken,
        },
        body: JSON.stringify({
          id: [id],
        }),
      }
    );
    const responceData = await response.json();

    console.log("deleteRule" + JSON.stringify(responceData));

    if (responceData.success === true) {
      const Data = async () => {
        if (props.selectedAccount !== "") {
          console.log(props.selectedAccount);
          setApiLoading(true);
          let userToken = localStorage.getItem("userToken");
          let AuthToken = "Bearer " + userToken;
          let url = apiEndPoint;
          let advancedFilters: any = [];

          if (props.filterData && props.filterData.length > 0) {
            advancedFilters = props.filterData;
          }

       
      let requestOptions: any = {};
      if (sortModeldata.length > 0) {
        requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: AuthToken,
          },
          body: JSON.stringify({
            pageNumber: props.currPage,
            pageSize: props.perPage,
            sortOptions: [
              {
                columnName: sortModeldata[0].field,
                direction: sortModeldata[0].sort=== "asc" ?"Ascending":"Descending",
              },
            ],
            globalFilters: {
              searchText: props.searchKey,
              advancedFilters: [
                String(props.selectedAccount),
                props.fetchRulesByStatus === "All Status"
                  ? ""
                  : props.fetchRulesByStatus,
              ],
            },
          }),
        };
      } else {
        requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: AuthToken,
          },
          body: JSON.stringify({
            pageNumber: props.currPage,
            pageSize: props.perPage,

            globalFilters: {
              searchText: props.searchKey,
              advancedFilters: [
                String(props.selectedAccount),
                props.fetchRulesByStatus === "All Status"
                  ? ""
                  : props.fetchRulesByStatus,
              ],
            },
          }),
        };
      }

          try {
            const response = await fetch(url, requestOptions);
            const responceData = await response.json();

            let pageConfigDetails = {
              total: responceData.result.total,
              currPage: responceData.result.currPage,
              lastPage: responceData.result.lastPage,
              nextPage: responceData.result.nextPage,
              perPage: responceData.result.perPage,
              prevPage: responceData.result.prevPage,
              dropdownDatas: responceData.result.headers,
            };

            props.parentCallback(pageConfigDetails);

          
            

            if (columns.length < 1) {
              let headers = responceData.result.headers;
              console.log(headers);

              for (let i = 0; headers.length > i; i++) {
                if (headers[i]["keyName"] === "status") {
                  columns.push({
                    field: headers[i]["keyName"],
                    headerName: headers[i]["displayName"],
                    width: 80,
                    renderCell: (params) => {
                      return (
                        <>
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckChecked"
                              onChange={() =>
                                statusHandler(params, params.row.profileId)
                              }
                              checked={
                                params.row.status === "Enabled" ? true : false
                              }
                            />
                          </div>
                        </>
                      );
                    },
                  });
                } else if (headers[i]["keyName"] === "ruleName") {
                  columns.push({
                    field: headers[i]["keyName"],
                    headerName: headers[i]["displayName"],
                    width: 200,
                minWidth: 200,
                maxWidth: 200,
                    flex: 0.7,
                    renderCell: (params) => {
                      return (
                        <>
                          <div className="col-rulename">
                            <div
                              className="col-title"
                              style={{ overflow: "hidden", whiteSpace: "normal", maxWidth: "200px",minWidth: "200px", }}
                            >
                              {params.row.ruleName}
                            </div>
                          </div>
                        </>
                      );
                    },
                  });
                } else if (headers[i]["keyName"] === "automationCriteria") {
                  columns.push({
                    field: headers[i]["keyName"],
                    headerName: headers[i]["displayName"],
                    flex: 1,
                    minWidth: 150,
                    maxWidth: 200,
                    renderCell: (params) => {
                      return (
                        <>
                          <div className="col-rulename">
                            {params.row.automationCriteria.map(
                              (automationCriteria, i) => (
                                <div
                                  key={i}
                                  style={{
                                    overflow: "hidden",
                                    whiteSpace: "normal",
                                  }}
                                >
                                  {automationCriteria}
                                </div>
                              )
                            )}
                          </div>
                        </>
                      );
                    },
                  });
                } else if (headers[i]["keyName"] === "matchTypes") {
                  columns.push({
                    field: headers[i]["keyName"],
                    headerName: headers[i]["displayName"],
                    width: 150,
                 
                    renderCell: (params) => {
                      return (
                        <>
                          <div className="col-rulename">
                            {params.row.matchTypes.map((value, i) => (
                              <div key={i}>{value}</div>
                            ))}
                          </div>
                        </>
                      );
                    },
                  });
                } else if (headers[i]["keyName"] === "frequency") {
                  columns.push({
                    field: headers[i]["keyName"],
                    headerName: headers[i]["displayName"],
                    width: 200,
                
                    renderCell: (params) => {
                      return (
                        <>
                          <div className="col-rulename">
                            <div className="">
                              Occurence : {params.row.frequency.occurence}{" "}
                            </div>
                            <div className="">
                              Time : {params.row.frequency.time}{" "}
                            </div>
                            <div className="">
                              DateRange : {params.row.frequency.dateRange}{" "}
                            </div>
                          </div>
                        </>
                      );
                    },
                  });
                } else if (headers[i]["keyName"] === "targetCriteria") {
                  columns.push({
                    field: headers[i]["keyName"],
                    headerName: headers[i]["displayName"],
                    flex: 1,
                    minWidth: 130,
                    renderCell: (params) => {
                      return (
                        <>
                          <div className="col-rulename">
                            {params.row.targetCriteria.map((value, i) => (
                              <div
                                key={i}
                                style={{ overflow: "hidden", whiteSpace: "normal" }}
                              >
                                {value}
                              </div>
                            ))}
                          </div>
                        </>
                      );
                    },
                  });
                } else if (headers[i]["keyName"] === "actionCriteria") {
                  columns.push({
                    field: headers[i]["keyName"],
                    headerName: headers[i]["displayName"],
                    flex: 1,
                    minWidth: 130,
                    renderCell: (params) => {
                      return (
                        <>
                          <div className="col-rulename">
                            {params.row.actionCriteria.map((value, i) => (
                              <div
                                key={i}
                                style={{ overflow: "hidden", whiteSpace: "normal" }}
                              >
                                {value}
                              </div>
                            ))}
                          </div>
                        </>
                      );
                    },
                  });
                } else if (headers[i]["keyName"] === "dateCreated") {
                  columns.push({
                    field: headers[i]["keyName"],
                    headerName: headers[i]["displayName"],
                    minWidth: 120,
                 
                    renderCell: (params) => {
                      return (
                        <>
                          <div className="col-rulename">
                            {params.row.dateCreated}
                          </div>
                        </>
                      );
                    },
                  });
                } else if (headers[i]["keyName"] === "mappedCampaignsCount") {
                      console.log("✅ Adding Mapped Campaigns Column");
                      columns.push({
                        field: "mappedCampaignsCount",
                        headerName: headers[i]["displayName"],
                        width: 150,
                        renderCell: (params) => (
                          <div className="col-rulename">
                            {params.row.mappedCampaignsCount}
                          </div>
                        ),
                      });
                    }

                  else {
                  columns.push({
                    field: headers[i]["keyName"],
                    headerName: headers[i]["displayName"],
                    minWidth: 100,
                    flex: 0.5,
                  });
                }
              }
              columns.push({
                field: "rowAction",
                headerName: "",
                sortable: false,
                filterable: false,
                disableColumnMenu: true,
                width: 50,
                renderCell: (params) => {
                  return (
                    <>
                      <div className="col-action-container text-right">
                        {/* <div
                          id={"dropdownMenuButton" + params.row.id}
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        > */}
                          {/* <img src={ActionDot} alt="actions" /> */}
                          <AiOutlineAudit />
                          <FaEdit />
                          <MdControlPointDuplicate />
                          <MdDelete />



                        {/* </div> */}
                        {/* <ul
                          className="dropdown-menu"
                          aria-labelledby={"dropdownMenuButton" + params.row.id}
                        >
                          <li>
                            <Link
                              to={
                                "/ads/automation-rules/audit-log/" +
                                params.row.id
                              }
                            >
                              <p className="dropdown-item">Audit Log</p>
                            </Link>
                          </li>
                          <li>
                            <Link
                              to={
                                "/ads/add-automation-newrules/" + params.row.id
                              }
                            >
                              <p className="dropdown-item">Edit</p>
                            </Link>
                          </li>
                          <li>
                            <p
                              className="dropdown-item"
                              onClick={(e) =>
                                Duplicaate(params.row.id, params.row.profileId)
                              }
                            >
                              Duplicate
                            </p>
                          </li>
                          <Popconfirm
                            title="Delete"
                            description="Are you sure you want to delete rules?"
                            onConfirm={(e) =>
                              deleteRule(params.row.id, params.row.profileId)
                            }
                            onCancel={cancel}
                            okText="Yes"
                            cancelText="No"
                          >
                            <li>
                              <p className="dropdown-item text-red">Delete</p>
                            </li>
                          </Popconfirm>
                        </ul> */}
                      </div>
                    </>
                  );
                },
              });
            }
            console.log("Columns header: ", columns);
            setIsRows(responceData.result.data);
            setApiLoading(false);
            console.log("Row data: ", rows);
          } catch (error) {
            setApiLoading(false);
            console.error("Error fetching data:", error);
          }
        }
      };
      Data();
      toast("Successfully Deleted");
    } else {
      toast("Unable to Deleted");
    }
  };
  
  const Duplicaate = async (id, profileId) => {
    console.log(profileId);

    let userToken = localStorage.getItem("userToken");
    let AuthToken = "Bearer " + userToken;
    const response = await fetch(
      "https://adsexpert-api.getgrowth.agency/Rule/Duplicate/" + id,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: AuthToken,
        },
        body: JSON.stringify({}),
      }
    );
    const responceData = await response.json();

    console.log("Duplicaate" + JSON.stringify(responceData));
    if (responceData.success === true) {
      const Data = async () => {
        if (props.selectedAccount !== "") {
          console.log(props.selectedAccount);
          setApiLoading(true);
          let userToken = localStorage.getItem("userToken");
          let AuthToken = "Bearer " + userToken;
          let url = apiEndPoint;
          let advancedFilters: any = [];

          if (props.filterData && props.filterData.length > 0) {
            advancedFilters = props.filterData;
          }

          let requestOptions: any = {};
          if (sortModeldata.length > 0) {
            requestOptions = {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: AuthToken,
              },
              body: JSON.stringify({
                pageNumber: props.currPage,
                pageSize: props.perPage,
                sortOptions: [
                  {
                    columnName: sortModeldata[0].field,
                    direction: sortModeldata[0].sort=== "asc" ?"Ascending":"Descending",
                  },
                ],
                globalFilters: {
                  searchText: props.searchKey,
                  advancedFilters: [
                    String(props.selectedAccount),
                    props.fetchRulesByStatus === "All Status"
                      ? ""
                      : props.fetchRulesByStatus,
                  ],
                },
              }),
            };
          } else {
            requestOptions = {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: AuthToken,
              },
              body: JSON.stringify({
                pageNumber: props.currPage,
                pageSize: props.perPage,
    
                globalFilters: {
                  searchText: props.searchKey,
                  advancedFilters: [
                    String(props.selectedAccount),
                    props.fetchRulesByStatus === "All Status"
                      ? ""
                      : props.fetchRulesByStatus,
                  ],
                },
              }),
            };
          }

          try {
            const response = await fetch(url, requestOptions);
            const responceData = await response.json();

            let pageConfigDetails = {
              total: responceData.result.total,
              currPage: responceData.result.currPage,
              lastPage: responceData.result.lastPage,
              nextPage: responceData.result.nextPage,
              perPage: responceData.result.perPage,
              prevPage: responceData.result.prevPage,
              dropdownDatas: responceData.result.headers,
            };

            props.parentCallback(pageConfigDetails);

            if (columns.length < 1) {
              let headers = responceData.result.headers;
              console.log(headers);

              for (let i = 0; headers.length > i; i++) {
                if (headers[i]["keyName"] === "status") {
                  columns.push({
                    field: headers[i]["keyName"],
                    headerName: headers[i]["displayName"],
                    width: 80,
                    renderCell: (params) => {
                      return (
                        <>
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckChecked"
                              onChange={() =>
                                statusHandler(params, params.row.profileId)
                              }
                              checked={
                                params.row.status === "Enabled" ? true : false
                              }
                            />
                          </div>
                        </>
                      );
                    },
                  });
                } else if (headers[i]["keyName"] === "ruleName") {
                  columns.push({
                    field: headers[i]["keyName"],
                    headerName: headers[i]["displayName"],
                    width: 200,
                minWidth: 200,
                maxWidth: 200,
                    flex: 0.7,
                    renderCell: (params) => {
                      return (
                        <>
                          <div className="col-rulename">
                            <div
                              className="col-title"
                              style={{ overflow: "hidden", whiteSpace: "normal",maxWidth:"200px" , minWidth:"200px" }}
                            >
                              {params.row.ruleName}
                            </div>
                          </div>
                        </>
                      );
                    },
                  });
                } else if (headers[i]["keyName"] === "automationCriteria") {
                  columns.push({
                    field: headers[i]["keyName"],
                    headerName: headers[i]["displayName"],
                    flex: 1,
                    minWidth: 150,
                    renderCell: (params) => {
                      return (
                        <>
                          <div className="col-rulename">
                            {params.row.automationCriteria.map(
                              (automationCriteria, i) => (
                                <div
                                  key={i}
                                  style={{
                                    overflow: "hidden",
                                    whiteSpace: "normal",
                                  }}
                                >
                                  {automationCriteria}
                                </div>
                              )
                            )}
                          </div>
                        </>
                      );
                    },
                  });
                } else if (headers[i]["keyName"] === "matchTypes") {
                  columns.push({
                    field: headers[i]["keyName"],
                    headerName: headers[i]["displayName"],
                    width: 150,
                 
                    renderCell: (params) => {
                      return (
                        <>
                          <div className="col-rulename">
                            {params.row.matchTypes.map((value, i) => (
                              <div key={i}>{value}</div>
                            ))}
                          </div>
                        </>
                      );
                    },
                  });
                } else if (headers[i]["keyName"] === "frequency") {
                  columns.push({
                    field: headers[i]["keyName"],
                    headerName: headers[i]["displayName"],
                    width: 200,
                
                    renderCell: (params) => {
                      return (
                        <>
                          <div className="col-rulename">
                            <div className="">
                              Occurence : {params.row.frequency.occurence}{" "}
                            </div>
                            <div className="">
                              Time : {params.row.frequency.time}{" "}
                            </div>
                            <div className="">
                              DateRange : {params.row.frequency.dateRange}{" "}
                            </div>
                          </div>
                        </>
                      );
                    },
                  });
                } else if (headers[i]["keyName"] === "targetCriteria") {
                  columns.push({
                    field: headers[i]["keyName"],
                    headerName: headers[i]["displayName"],
                    flex: 1,
                    minWidth: 130,
                    renderCell: (params) => {
                      return (
                        <>
                          <div className="col-rulename">
                            {params.row.targetCriteria.map((value, i) => (
                              <div
                                key={i}
                                style={{ overflow: "hidden", whiteSpace: "normal" }}
                              >
                                {value}
                              </div>
                            ))}
                          </div>
                        </>
                      );
                    },
                  });
                } else if (headers[i]["keyName"] === "actionCriteria") {
                  columns.push({
                    field: headers[i]["keyName"],
                    headerName: headers[i]["displayName"],
                    flex: 1,
                    minWidth: 130,
                    renderCell: (params) => {
                      return (
                        <>
                          <div className="col-rulename">
                            {params.row.actionCriteria.map((value, i) => (
                              <div
                                key={i}
                                style={{ overflow: "hidden", whiteSpace: "normal" }}
                              >
                                {value}
                              </div>
                            ))}
                          </div>
                        </>
                      );
                    },
                  });
                } else if (headers[i]["keyName"] === "dateCreated") {
                  columns.push({
                    field: headers[i]["keyName"],
                    headerName: headers[i]["displayName"],
                    minWidth: 120,
                 
                    renderCell: (params) => {
                      return (
                        <>
                          <div className="col-rulename">
                            {params.row.dateCreated}
                          </div>
                        </>
                      );
                    },
                  });
                } else {
                  columns.push({
                    field: headers[i]["keyName"],
                    headerName: headers[i]["displayName"],
                    minWidth: 100,
                    flex: 0.5,
                  });
                }
              }
              columns.push({
                field: "rowAction",
                headerName: "",
                sortable: false,
                filterable: false,
                disableColumnMenu: true,
                width: 50,
                renderCell: (params) => {
                  return (
                    <>
                      <div className="col-action-container text-right">
                        {/* <div
                          id={"dropdownMenuButton" + params.row.id}
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <img src={ActionDot} alt="actions" />
                        </div> */}
                        <AiOutlineAudit />
                          <FaEdit />
                          <MdControlPointDuplicate />
                          <MdDelete />
                        {/* <ul
                          className="dropdown-menu"
                          aria-labelledby={"dropdownMenuButton" + params.row.id}
                        >
                          <li>
                            <Link
                              to={
                                "/ads/automation-rules/audit-log/" +
                                params.row.id
                              }
                            >
                              <p className="dropdown-item">Audit Log</p>
                            </Link>
                          </li>
                          <li>
                            <Link
                              to={
                                "/ads/add-automation-newrules/" + params.row.id
                              }
                            >
                              <p className="dropdown-item">Edit</p>
                            </Link>
                          </li>
                          <li>
                            <p
                              className="dropdown-item"
                              onClick={(e) =>
                                Duplicaate(params.row.id, params.row.profileId)
                              }
                            >
                              Duplicate
                            </p>
                          </li>
                          <Popconfirm
                            title="Delete"
                            description="Are you sure you want to delete rules?"
                            onConfirm={(e) =>
                              deleteRule(params.row.id, params.row.profileId)
                            }
                            onCancel={cancel}
                            okText="Yes"
                            cancelText="No"
                          >
                            <li>
                              <p className="dropdown-item text-red">Delete</p>
                            </li>
                          </Popconfirm>
                        </ul> */}
                      </div>
                    </>
                  );
                },
              });
            }
            console.log("Columns header: ", columns);
            setIsRows(responceData.result.data);
            setApiLoading(false);
            console.log("Row data: ", rows);
          } catch (error) {
            setApiLoading(false);
            console.error("Error fetching data:", error);
          }
        }
      };
      Data();
      toast("Successfully Duplicated");
    } else {
      toast("Unable to Duplicate");
    }
  };

  const statusHandler = async (params, profileId) => {
    // Update the status in the local state
    setIsRows((prevRows) =>
      prevRows.map((row) =>
        row.id === params.row.id
          ? { ...row, status: row.status === "Paused" ? "Enabled" : "Paused" }
          : row
      )
    );

    try {
      // Retrieve token from local storage and set up the authorization header
      let userToken = localStorage.getItem("userToken");
      let AuthToken = "Bearer " + userToken;

      // Perform the PUT request
      const response = await fetch(
        "https://adsexpert-api.getgrowth.agency/Rule/Status",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: AuthToken,
          },
          body: JSON.stringify({
            ruleId: [params.row.id],
            status: params.row.status === "Paused" ? "Enabled" : "Paused",
          }),
        }
      );

      // Parse the response data
      const responseData = await response.json();
      console.log("Duplicate" + JSON.stringify(responseData));

      // Check the response and show appropriate toast messag

      if (responseData.success === true) {
        const Data = async () => {
          if (props.selectedAccount !== "") {
            console.log(props.selectedAccount);
            setApiLoading(true);
            let userToken = localStorage.getItem("userToken");
            let AuthToken = "Bearer " + userToken;
            let url = apiEndPoint;
            let advancedFilters: any = [];

            if (props.filterData && props.filterData.length > 0) {
              advancedFilters = props.filterData;
            }

            let requestOptions: any = {};
            if (sortModeldata.length > 0) {
              requestOptions = {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: AuthToken,
                },
                body: JSON.stringify({
                  pageNumber: props.currPage,
                  pageSize: props.perPage,
                  sortOptions: [
                    {
                      columnName: sortModeldata[0].field,
                      direction: sortModeldata[0].sort=== "asc" ?"Ascending":"Descending",
                    },
                  ],
                  globalFilters: {
                    searchText: props.searchKey,
                    advancedFilters: [
                      String(props.selectedAccount),
                      props.fetchRulesByStatus === "All Status"
                        ? ""
                        : props.fetchRulesByStatus,
                    ],
                  },
                }),
              };
            } else {
              requestOptions = {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: AuthToken,
                },
                body: JSON.stringify({
                  pageNumber: props.currPage,
                  pageSize: props.perPage,
      
                  globalFilters: {
                    searchText: props.searchKey,
                    advancedFilters: [
                      String(props.selectedAccount),
                      props.fetchRulesByStatus === "All Status"
                        ? ""
                        : props.fetchRulesByStatus,
                    ],
                  },
                }),
              };
            }

            try {
              const response = await fetch(url, requestOptions);
              const responceData = await response.json();

              let pageConfigDetails = {
                total: responceData.result.total,
                currPage: responceData.result.currPage,
                lastPage: responceData.result.lastPage,
                nextPage: responceData.result.nextPage,
                perPage: responceData.result.perPage,
                prevPage: responceData.result.prevPage,
                dropdownDatas: responceData.result.headers,
              };

              props.parentCallback(pageConfigDetails);

              if (columns.length < 1) {
                let headers = responceData.result.headers;
                console.log(headers);

                for (let i = 0; headers.length > i; i++) {
                  if (headers[i]["keyName"] === "status") {
                    columns.push({
                      field: headers[i]["keyName"],
                      headerName: headers[i]["displayName"],
                      width: 80,
                      renderCell: (params) => {
                        return (
                          <>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="flexSwitchCheckChecked"
                                onChange={() =>
                                  statusHandler(params, params.row.profileId)
                                }
                                checked={
                                  params.row.status === "Enabled" ? true : false
                                }
                              />
                            </div>
                          </>
                        );
                      },
                    });
                  } else if (headers[i]["keyName"] === "ruleName") {
                    columns.push({
                      field: headers[i]["keyName"],
                      headerName: headers[i]["displayName"],
                      width: 200,
                      minWidth: 200,
                      maxWidth: 200,
                      flex: 0.7,
                      renderCell: (params) => {
                        return (
                          <>
                            <div className="col-rulename">
                              <div
                                className="col-title"
                                style={{ overflow: "hidden", whiteSpace: "normal",maxWidth: "200px",minWidth: "200px", }}
                              >
                                {params.row.ruleName}
                              </div>
                            </div>
                          </>
                        );
                      },
                    });
                  } else if (headers[i]["keyName"] === "automationCriteria") {
                    columns.push({
                      field: headers[i]["keyName"],
                      headerName: headers[i]["displayName"],
                      flex: 1,
                      minWidth: 150,
                      renderCell: (params) => {
                        return (
                          <>
                            <div className="col-rulename">
                              {params.row.automationCriteria.map(
                                (automationCriteria, i) => (
                                  <div
                                    key={i}
                                    style={{
                                      overflow: "hidden",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {automationCriteria}
                                  </div>
                                )
                              )}
                            </div>
                          </>
                        );
                      },
                    });
                  } else if (headers[i]["keyName"] === "matchTypes") {
                    columns.push({
                      field: headers[i]["keyName"],
                      headerName: headers[i]["displayName"],
                      width: 150,
                   
                      renderCell: (params) => {
                        return (
                          <>
                            <div className="col-rulename">
                              {params.row.matchTypes.map((value, i) => (
                                <div key={i}>{value}</div>
                              ))}
                            </div>
                          </>
                        );
                      },
                    });
                  } else if (headers[i]["keyName"] === "frequency") {
                    columns.push({
                      field: headers[i]["keyName"],
                      headerName: headers[i]["displayName"],
                      width: 200,
                  
                      renderCell: (params) => {
                        return (
                          <>
                            <div className="col-rulename">
                              <div className="">
                                Occurence : {params.row.frequency.occurence}{" "}
                              </div>
                              <div className="">
                                Time : {params.row.frequency.time}{" "}
                              </div>
                              <div className="">
                                DateRange : {params.row.frequency.dateRange}{" "}
                              </div>
                            </div>
                          </>
                        );
                      },
                    });
                  } else if (headers[i]["keyName"] === "targetCriteria") {
                    columns.push({
                      field: headers[i]["keyName"],
                      headerName: headers[i]["displayName"],
                      flex: 1,
                      minWidth: 130,
                      renderCell: (params) => {
                        return (
                          <>
                            <div className="col-rulename">
                              {params.row.targetCriteria.map((value, i) => (
                                <div
                                  key={i}
                                  style={{ overflow: "hidden", whiteSpace: "normal" }}
                                >
                                  {value}
                                </div>
                              ))}
                            </div>
                          </>
                        );
                      },
                    });
                  } else if (headers[i]["keyName"] === "actionCriteria") {
                    columns.push({
                      field: headers[i]["keyName"],
                      headerName: headers[i]["displayName"],
                      flex: 1,
                      minWidth: 130,
                      renderCell: (params) => {
                        return (
                          <>
                            <div className="col-rulename">
                              {params.row.actionCriteria.map((value, i) => (
                                <div
                                  key={i}
                                  style={{ overflow: "hidden", whiteSpace: "normal" }}
                                >
                                  {value}
                                </div>
                              ))}
                            </div>
                          </>
                        );
                      },
                    });
                  } else if (headers[i]["keyName"] === "dateCreated") {
                    columns.push({
                      field: headers[i]["keyName"],
                      headerName: headers[i]["displayName"],
                      minWidth: 120,
                   
                      renderCell: (params) => {
                        return (
                          <>
                            <div className="col-rulename">
                              {params.row.dateCreated}
                            </div>
                          </>
                        );
                      },
                    });
                  } else {
                    columns.push({
                      field: headers[i]["keyName"],
                      headerName: headers[i]["displayName"],
                      minWidth: 100,
                      flex: 0.5,
                    });
                  }
                }
                columns.push({
                  field: "rowAction",
                  headerName: "",
                  sortable: false,
                  filterable: false,
                  disableColumnMenu: true,
                  width: 50,
                  renderCell: (params) => {
                    return (
                      <>
                        <div className="col-action-container text-right">
                        <AiOutlineAudit />
                          <FaEdit />
                          <MdControlPointDuplicate />
                          <MdDelete />
                          {/* <div
                            id={"dropdownMenuButton" + params.row.id}
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <img src={ActionDot} alt="actions" />
                          </div> */}
                          {/* <ul
                            className="dropdown-menu"
                            aria-labelledby={
                              "dropdownMenuButton" + params.row.id
                            }
                          >
                            <li>
                              <Link
                                to={
                                  "/ads/automation-rules/audit-log/" +
                                  params.row.id
                                }
                              >
                                <p className="dropdown-item">Audit Log</p>
                              </Link>
                            </li>
                            <li>
                              <Link
                                to={
                                  "/ads/add-automation-newrules/" +
                                  params.row.id
                                }
                              >
                                <p className="dropdown-item">Edit</p>
                              </Link>
                            </li>
                            <li>
                              <p
                                className="dropdown-item"
                                onClick={(e) =>
                                  Duplicaate(
                                    params.row.id,
                                    params.row.profileId
                                  )
                                }
                              >
                                Duplicate
                              </p>
                            </li>
                            <Popconfirm
                              title="Delete"
                              description="Are you sure you want to delete rules?"
                              onConfirm={(e) =>
                                deleteRule(params.row.id, params.row.profileId)
                              }
                              onCancel={cancel}
                              okText="Yes"
                              cancelText="No"
                            >
                              <li>
                                <p className="dropdown-item text-red">Delete</p>
                              </li>
                            </Popconfirm>
                          </ul> */}
                        </div>
                      </>
                    );
                  },
                });
              }
              console.log("Columns header: ", columns);
              setIsRows(responceData.result.data);
              setApiLoading(false);
              console.log("Row data: ", rows);
            } catch (error) {
              setApiLoading(false);
              console.error("Error fetching data:", error);
            }
          }
        };
        Data();
        const toastMessage =
          params.row.status === "Paused"
            ? "Successfully Enabled"
            : "Successfully Paused";
        toast(toastMessage);
      } else {
        toast("Unable to Perform Action");
      }
    } catch (error) {
      console.error(error);
      toast("An error occurred. Please try again.");
    }
  };

  const fetchData = async () => {
    if (props.selectedAccount !== "") {
      console.log(props.selectedAccount);
      setApiLoading(true);
      let userToken = localStorage.getItem("userToken");
      let AuthToken = "Bearer " + userToken;
      let url = apiEndPoint;
      let advancedFilters: any = [];

      if (props.filterData && props.filterData.length > 0) {
        advancedFilters = props.filterData;
      }

      let requestOptions: any = {};
      if (sortModeldata.length > 0) {
        requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: AuthToken,
          },
          body: JSON.stringify({
            pageNumber: props.currPage,
            pageSize: props.perPage,
            sortOptions: [
              {
                columnName: sortModeldata[0].field,
                direction: sortModeldata[0].sort=== "asc" ?"Ascending":"Descending",
              },
            ],
            globalFilters: {
              searchText: props.searchKey,
              advancedFilters: [
                String(props.selectedAccount),
                props.fetchRulesByStatus === "All Status"
                  ? ""
                  : props.fetchRulesByStatus,
              ],
            },
          }),
        };
      } else {
        requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: AuthToken,
          },
          body: JSON.stringify({
            pageNumber: props.currPage,
            pageSize: props.perPage,

            globalFilters: {
              searchText: props.searchKey,
              advancedFilters: [
                String(props.selectedAccount),
                props.fetchRulesByStatus === "All Status"
                  ? ""
                  : props.fetchRulesByStatus,
              ],
            },
          }),
        };
      }

      try {
        const response = await fetch(url, requestOptions);
        const responceData = await response.json();
        let pageConfigDetails = {
          total: responceData.result.total,
          filteredCount: responceData.result.filteredCount,
          currPage: responceData.result.currPage,
          lastPage: responceData.result.lastPage,
          nextPage: responceData.result.nextPage,
          perPage: responceData.result.perPage,
          prevPage: responceData.result.prevPage,
          dropdownDatas: responceData.result.headers,
        };

        props.parentCallback(pageConfigDetails);
        setHeader(responceData.result.headers)

        if (columns.length < 1) {
          let headers = responceData.result.headers;
          console.log(headers);

          for (let i = 0; headers.length > i; i++) {
            if (headers[i]["keyName"] === "status") {
              columns.push({
                field: headers[i]["keyName"],
                headerName: headers[i]["displayName"],
                width: 80,
                renderCell: (params) => {
                  return (
                    <>
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          id="flexSwitchCheckChecked"
                          onChange={() =>
                            statusHandler(params, params.row.profileId)
                          }
                          checked={
                            params.row.status === "Enabled" ? true : false
                          }
                        />
                      </div>
                    </>
                  );
                },
              });
            } else if (headers[i]["keyName"] === "ruleName") {
              columns.push({
                field: headers[i]["keyName"],
                headerName: headers[i]["displayName"],
                width: 200,
                minWidth: 200,
                maxWidth: 200,
                flex: 1,
                renderCell: (params) => {
                  return (
                    <>
                      <div className="col-rulename">
                      <div
                          className="col-title"
                          style={{ overflow: "hidden", whiteSpace: "normal",width: "200px",minWidth: "200px", maxWidth:"200px" }}
                        >
                          {params.row.ruleName}
                        </div>
                      </div>
                    </>
                  );
                },
              });
            } else if (headers[i]["keyName"] === "automationCriteria") {
              columns.push({
                field: headers[i]["keyName"],
                headerName: headers[i]["displayName"],
                flex: 1,
                minWidth: 200,
                renderCell: (params) => {
                  return (
                    <>
                      <div className="col-rulename">
                        {params.row.automationCriteria.map(
                          (automationCriteria, i) => (
                            <div
                              key={i}
                              style={{
                                overflow: "hidden",
                                whiteSpace: "normal",
                                minWidth: 200,
                              }}
                            >
                              {automationCriteria}
                            </div>
                          )
                        )}
                      </div>
                    </>
                  );
                },
              });
            } else if (headers[i]["keyName"] === "matchTypes") {
              columns.push({
                field: headers[i]["keyName"],
                headerName: headers[i]["displayName"],
                width: 150,
             
                renderCell: (params) => {
                  return (
                    <>
                      <div className="col-rulename">
                        {params.row.matchTypes.map((value, i) => (
                          <div key={i}>{value}</div>
                        ))}
                      </div>
                    </>
                  );
                },
              });
            } else if (headers[i]["keyName"] === "frequency") {
              columns.push({
                field: headers[i]["keyName"],
                headerName: headers[i]["displayName"],
                width: 200,
            
                renderCell: (params) => {
                  return (
                    <>
                      <div className="col-rulename">
                        <div className="">
                          Occurence : {params.row.frequency.occurence}{" "}
                        </div>
                        <div className="">
                          Time : {params.row.frequency.time}{" "}
                        </div>
                        <div className="">
                          DateRange : {params.row.frequency.dateRange}{" "}
                        </div>
                      </div>
                    </>
                  );
                },
              });
            } else if (headers[i]["keyName"] === "targetCriteria") {
              columns.push({
                field: headers[i]["keyName"],
                headerName: headers[i]["displayName"],
                flex: 1,
                minWidth: 130,
                renderCell: (params) => {
                  return (
                    <>
                      <div className="col-rulename">
                        {params.row.targetCriteria.map((value, i) => (
                          <div
                            key={i}
                            style={{ overflow: "hidden", whiteSpace: "normal" }}
                          >
                            {value}
                          </div>
                        ))}
                      </div>
                    </>
                  );
                },
              });
            } else if (headers[i]["keyName"] === "actionCriteria") {
              columns.push({
                field: headers[i]["keyName"],
                headerName: headers[i]["displayName"],
                flex: 1,
                minWidth: 130,
                renderCell: (params) => {
                  return (
                    <>
                      <div className="col-rulename">
                        {params.row.actionCriteria.map((value, i) => (
                          <div
                            key={i}
                            style={{ overflow: "hidden", whiteSpace: "normal" }}
                          >
                            {value}
                          </div>
                        ))}
                      </div>
                    </>
                  );
                },
              });
            } else if (headers[i]["keyName"] === "dateCreated") {
              columns.push({
                field: headers[i]["keyName"],
                headerName: headers[i]["displayName"],
                minWidth: 120,
             
                renderCell: (params) => {
                  return (
                    <>
                      <div className="col-rulename">
                        {params.row.dateCreated}
                      </div>
                    </>
                  );
                },
              });
            } else {
              columns.push({
                field: headers[i]["keyName"],
                headerName: headers[i]["displayName"],
                minWidth: 100,
                flex: 0.5,
              });
            }
          }
          columns.push({
            field: "rowAction",
            headerName: "",
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            width: 150,
            renderCell: (params) => {
              return (
                <>
                  <div className="col-action-container d-flex align-items-center text-right" >
                    {/* <div
                      id={"dropdownMenuButton" + params.row.id}
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <img src={ActionDot} alt="actions" />
                    </div>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby={"dropdownMenuButton" + params.row.id}
                    >
                      <li>
                        <Link
                          to={
                            "/ads/automation-rules/audit-log/" + params.row.id 
                          }
                        >
                          <p className="dropdown-item">Audit Log</p>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={"/ads/add-automation-newrules/" + params.row.id +"/rules"}
                        >
                          <p className="dropdown-item">Edit</p>
                        </Link>
                      </li>
                      <li>
                        <p
                          className="dropdown-item"
                          onClick={(e) =>
                            Duplicaate(params.row.id, params.row.profileId)
                          }
                        >
                          Duplicate
                        </p>
                      </li>
                      <Popconfirm
                        title="Delete"
                        description="Are you sure you want to delete rules?"
                        onConfirm={(e) =>
                          deleteRule(params.row.id, params.row.profileId)
                        }
                        onCancel={cancel}
                        okText="Yes"
                        cancelText="No"
                      >
                        <li>
                          <p className="dropdown-item text-red">Delete</p>
                        </li>
                      </Popconfirm>
                    </ul> */}
                    
                    <TP  title="Audit" arrow placement="top"
                          slotProps={{
                            popper: {
                              modifiers: [
                                {
                                  name: 'offset',
                                  options: {
                                    offset: [0, -10], // Adjust this value as needed
                                  },
                                },
                              ],
                            },
                          }}>  
                    <Link
                          to={
                            "/ads/automation-rules/audit-log/" + params.row.id 
                          }
                        >
                          <AiOutlineAudit style={{fontSize:"1.2rem"}}/>
                          </Link>
                    </TP>
                    <TP  title="Edit" arrow placement="top"
                          slotProps={{
                            popper: {
                              modifiers: [
                                {
                                  name: 'offset',
                                  options: {
                                    offset: [0, -10], // Adjust this value as needed
                                  },
                                },
                              ],
                            },
                          }}>
                       <Link
                          to={"/ads/add-automation-newrules/" + params.row.id +"/rules"}
                        > <FaEdit  className="mx-2" style={{color:"green",fontSize:"1.2rem"}}/></Link></TP >
<TP title="Duplicate" arrow placement="top"
                          slotProps={{
                            popper: {
                              modifiers: [
                                {
                                  name: 'offset',
                                  options: {
                                    offset: [0, -10], // Adjust this value as needed
                                  },
                                },
                              ],
                            },
                          }}>
<span><MdControlPointDuplicate style={{fontSize:"1.3rem",color:"#ffb000"}} onClick={(e) =>
                            Duplicaate(params.row.id, params.row.profileId)
                          }/></span>
                          </TP>
                          <Popconfirm
                          title="Delete"
                          description="Are you sure you want to delete rules?"
                          onConfirm={(e) =>
                            deleteRule(params.row.id, params.row.profileId)
                          }
                          onCancel={cancel} 
                          okText="Yes"
                          cancelText="No"
                        >
                     <TP title="Delete" arrow placement="top"
                          slotProps={{
                            popper: {
                              modifiers: [
                                {
                                  name: 'offset',
                                  options: {
                                    offset: [0, -10], // Adjust this value as needed
                                  },
                                },
                              ],
                            },
                          }}>
                    <span> <MdDelete className="ms-2"  style={{color:"#dc3545",fontSize:'1.2rem'}} /></span>
                     </TP>
                        </Popconfirm>
                  </div>
                </>
              );
            },
          });
        }
        setIsRows(responceData.result.data);
        console.log("Columns header: ", columns);
        setApiLoading(false);
        console.log("Row data: ", responceData.result.data);
      } catch (error) {
        setApiLoading(false);
        console.error("Error fetching data:", error);
      }
    }
  };

  const handleSortModelChange = (model) => {
    if(model.length > 0){
    console.log(model);
    const data = header.filter(
      (header) => header.keyName === model[0]?.field
    );
    console.log(data);
    setSortModel(model)

    setSortModelData((prevSortModel) => ([{
      ...prevSortModel,
      field: data[0].name,
      sort: model[0].sort
    }]));

    const sort =[{
      field: data[0].name,
      sort: model[0].sort
    }]

    localStorage.setItem("Sort", JSON.stringify(sort));
    localStorage.setItem("SortData", JSON.stringify(model));

  }
  else{
    setSortModelData([])
    setSortModel([])
  }
  };

 const tableRef = useRef<HTMLTableElement | null>(null);
  const tableThRef = useRef<(HTMLTableCellElement | null)[]>([]);
const containerRef = useRef<HTMLDivElement | null>(null);


useLayoutEffect(() => {
  const table = tableRef.current;
  const headers = tableThRef.current;

  if (!table || headers.length === 0 || headers.some((th) => !th)) return;

  headers.forEach((th, index) => {
  if (!th || index === headers.length - 1) return;


    if (th.querySelector(".resizer")) return;

    const resizer = document.createElement("div");
    resizer.className = "resizer";
    resizer.style.cssText = `
      position: absolute;
      right: 0;
      top: 0;
      width: 5px;
      cursor: col-resize;
      user-select: none;
      height: 100%;
      z-index: 1;
    `;
    th.appendChild(resizer);

    let startX = 0;
    let startWidth = 0;

    const onMouseDown = (e: MouseEvent) => {
      e.preventDefault();
      startX = e.pageX;
      startWidth = th.offsetWidth;
      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
    };

    const onMouseMove = (e: MouseEvent) => {
      const newWidth = startWidth + (e.pageX - startX);
      if (newWidth > 30) {
        th.style.width = `${newWidth}px`;

        // Also update corresponding <td> width
        const rows = table.getElementsByTagName("tr");
        for (let i = 1; i < rows.length; i++) {
          const cell = rows[i].children[index] as HTMLElement;
          if (cell) cell.style.width = `${newWidth}px`;
        }
      }
    };

    const onMouseUp = () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };


     console.log(columns,'columnscolumns');
    

    resizer.addEventListener("mousedown", onMouseDown);
  });
}, [columns, rows]);


const visibleColumns = columns.filter((col) => col.headerName?.trim());

  return (
    <div >
      <div style={{ height: "calc(78vh - 120px)", width: "100%" }}>
        {!apiLoading ? (
          <>
            <div
              className="modal fade"
              id="addTagModel"
              aria-hidden="true"
              aria-labelledby="exampleModalToggleLabel3"
            >
              <div className="modal-dialog ">
                <div className="modal-content addTagModel">
                  <Row className="addTagInputContainer">
                    <Col md={12}>
                      <input
                        type="text"
                        className="form-control"
                        onChange={tagInputValue}
                      />
                    </Col>
                    <div className="addTagbtnContainer">
                      <button
                        type="button"
                        className="addTagBtn btn btn-primary"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={patchTagData}
                      >
                        Add
                      </button>
                    </div>
                  </Row>
                </div>
              </div>
            </div>


            {/* <DataGrid
              rows={rows}
              columns={columns}
              checkboxSelection={true}
              hideFooter={true}
              getRowHeight={() => 'auto'}
              onRowSelectionModelChange={(newSelection) => {
                setRowSelectionModel(newSelection);
              }}
              disableRowSelectionOnClick
              sortModel={sortModel}
              sortingMode="server"
              onSortModelChange={handleSortModelChange}
            /> */}


            <div className='border border-0 ' ref={containerRef}>
 <table className="full-table table-bordered" ref={tableRef}>
<thead className='table-heaads'>
  <tr>
   
    <th ref={(el) => (tableThRef.current[0] = el)}
      

      >
      <div className="thead__Checkbox">
 <input
        className="form-check-input"
   style={{borderColor:'2px solid red'}}
        type="checkbox"
        checked={rowSelectionModel.length === rows.length && rows.length > 0}
        onChange={handleSelectAllChange}
      />
      </div>
     
    </th>

   
     {visibleColumns.map((col, index) => (
        <th
          key={index}
          ref={(el) => {
            tableThRef.current[index + 1] = el;
          }}
                onClick={(e) => {
   
    if ((e.target as HTMLElement).classList.contains("resizer")) return;
    handleSort(col.field);
  }}
          style={{ cursor: 'pointer', position: 'relative' }}
        >
          {col.headerName}
          {sortKey === col.field ? (
            sortOrder === 'asc' ? ' ↑' : ' ↓'
          ) : (
            <span className="ms-2">↕</span>
          )}
        </th>
      ))}


          {/* {columns.map((col, index) => (
      <th
        key={index}
        ref={(el) => {
          tableThRef.current[index + 1] = el; 
        }}
        onClick={() => handleSort(col.field)}
        style={{ cursor: 'pointer', position: 'relative' }}
      >
        {col.headerName}
        {sortKey === col.field ? (
          sortOrder === 'asc' ? ' ↑' : ' ↓'
        ) : (
          <span className="ms-2">↕</span>
        )}
      </th>
    ))} */}

    {/* Actions Header */}
    <th ref={(el) => (tableThRef.current[columns.length + 1] = el)}></th>
  </tr>
</thead>

   <tbody>
    {sortedRows.length === 0 ? (
      <tr>
        <td colSpan={visibleColumns.length + 2} className="text-center">No Rows</td>
      </tr>
    ) : (
      sortedRows.map((row) => (
        <tr key={row.id}>
          {/* Row Checkbox */}
          <td>
            <div className="thead__Checkbox">
              <input
                className="form-check-input"
                type="checkbox"
                checked={rowSelectionModel.includes(row.id)}
                onChange={() => handleRowCheckboxChange(row.id)}
              />
            </div>
          </td>

          {/* Visible Column Data */}
          {visibleColumns.map((col, i) => {
            const value = row[col.field];

            if (col.field === 'status') {
              return (
                <td key={i}>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id={`flexSwitch-${row.id ?? "unknown"}`}
                      onChange={() => statusHandler({ row }, row.profileId)}
                      checked={row.status === "Enabled"}
                    />
                  </div>
                </td>
              );
            }

            if (Array.isArray(value)) {
              return (
                <td key={i}>
                  {value.map((v, j) => <div key={j}>{v}</div>)}
                </td>
              );
            }

            if (value && typeof value === 'object') {
              return (
                <td key={i}>
                  {Object.entries(value).map(([k, v], j) => (
                    <div key={j}><strong>{k}:</strong> {String(v)}</div>
                  ))}
                </td>
              );
            }

            return <td key={i}>{value}</td>;
          })}

          {/* Actions */}
     {rows.length === 0?'':   <td>
            <TP title="Audit" arrow placement="top"
              slotProps={{ popper: { modifiers: [{ name: 'offset', options: { offset: [0, -10] } }] } }}>
              <Link to={`/ads/automation-rules/audit-log/${row.id}`}>
                <AiOutlineAudit style={{ fontSize: "1.2rem" }} />
              </Link>
            </TP>

            <TP title="Edit" arrow placement="top"
              slotProps={{ popper: { modifiers: [{ name: 'offset', options: { offset: [0, -10] } }] } }}>
              <Link to={`/ads/add-automation-newrules/${row.id}/rules`}>
                <FaEdit className="mx-2" style={{ color: "green", fontSize: "1.2rem" }} />
              </Link>
            </TP>

            <TP title="Duplicate" arrow placement="top"
              slotProps={{ popper: { modifiers: [{ name: 'offset', options: { offset: [0, -10] } }] } }}>
              <span>
                <MdControlPointDuplicate
                  style={{ fontSize: "1.3rem", color: "#ffb000" }}
                  onClick={() => {
                    if (row?.id && row?.profileId) {
                      Duplicaate(row.id, row.profileId);
                    } else {
                      toast("Invalid row data");
                    }
                  }}
                />
              </span>
            </TP>

            <Popconfirm
              title="Delete"
              description="Are you sure you want to delete rules?"
              onConfirm={() => deleteRule(row.id, row.profileId)}
              onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
              <TP title="Delete" arrow placement="top"
                slotProps={{ popper: { modifiers: [{ name: 'offset', options: { offset: [0, -10] } }] } }}>
                <span>
                  <MdDelete className="ms-2" style={{ color: "#dc3545", fontSize: '1.2rem' }} />
                </span>
              </TP>
            </Popconfirm>
          </td>}    
   
        </tr>
      ))
    )}
  </tbody>
</table>

</div>  

        {/* <div className='Budget-tables table-wrappers' ref={containerRef}>
          <table className= "full-tables" ref={tableRef}>
  <thead className='table-heaads'>
    <tr>
      <th ref={el => tableThRef.current[0] = el}>Rule Name</th>
      <th ref={el => tableThRef.current[1] = el}>Status</th>
      <th ref={el => tableThRef.current[2] = el}>Marketplace</th>
      <th ref={el => tableThRef.current[3] = el}>Created Date</th>
      <th ref={el => tableThRef.current[4] = el}>Actions</th>
    </tr>
  </thead>


    <tbody>
      <tr>
        <td>Auto Price Adjust</td>
        <td>Active</td>
        <td>Amazon</td>
        <td>2025-04-29</td>
        <td><button>View</button></td>
      </tr>
      <tr>
        <td>Stock Monitor</td>
        <td>Paused</td>
        <td>eBay</td>
        <td>2025-04-25</td>
        <td><button>Edit</button></td>
      </tr>
    </tbody>
  </table>
</div> */}
          </>
        ) : (
          <div className="loading-container">
            <div
              style={{
                position: "absolute",
                top: "30%",
                left: 0,
                width: "100%",
                height: "100%",
              }}
            >
              <CircularProgress
                className="loading"
                style={{ margin: "auto" }}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
export default AutomationRulesListTable;
